const roadmapPage = {
  title: "מפת דרכים",
  description: "שלבי פיתוח של vBrain.io",
  back: "חזרה",
  openInNotion: "פתח ב-Notion",
  taskCount: "פריטים",
  effort: "מאמץ",
  goal: "יעד",
  epic: "אפיק",
  sprint: "ספרינט",
  task: "משימה",
  portfolio: "תיק",
  project: "פרויקט",
  subTask: "תת-משימה",
  notStarted: "טרם התחיל",
  inProgress: "בתהליך",
  complete: "הושלם",
  allItems: "כל הפריטים",
  noItems: "אין פריטים בשכבה זו",
  drillDown: "הצג",
  breadcrumbHome: "יעדים",
  viewHierarchy: "היררכיה",
  viewPortfolio: "לפי תיק",
  viewStatus: "לפי סטטוס",
  viewSprint: "לפי ספרינט",
  noStatus: "ללא סטטוס",
  portfolioCount: "תיקים",
  projectCount: "פרויקטים",
  sprintCount: "ספרינטים",
  doneLabel: "הושלמו",
  assignedTasks: "משויכות",
  unassignedTasks: "לא משויכות",
  unassignedTasksTitle: "משימות לא משויכות לספרינט",
} as const;
export default roadmapPage;
